import PersonalDetailsAnswers from '../../components/Questions/PersonalDetailsQuestion/PersonalDetailsAnswers'

const mapToDateOfBirth = (personalDetails: PersonalDetailsAnswers): string => {
  const day = personalDetails.dateOfBirth?.day
  const month = personalDetails.dateOfBirth?.month
  const year = personalDetails.dateOfBirth?.year
  if (!day || !month || !year) return ''

  return new Date(`${year}-${`0${month}`.slice(-2)}-${`0${day}`.slice(-2)}T00:00:00Z`).toISOString()
}

export default mapToDateOfBirth
